<script>
  import Section from './comp/section.svelte';
  import CenterDesc from './comp/center-desc.svelte';
  import LogGrid from './comp/log-card.svelte';
  import UsageCard from './comp/usage-card.svelte';
  import VerticalSpacing from './comp/vertical-spacing.svelte';
  const sectionDataCreator = (idKor, idEn, descMain, descSub) => {
    return {
      idKor: idKor,
      idEn: idEn,
      descMain: descMain,
      descSub: descSub,
    };
  };
  const sectionData = sectionDataCreator(
    '소개',
    'Introduce',
    ['즐기기만 하세요.', '준비는 메쥬가 할게요.'],
    [
      '무언갈 시작하기 위한 준비물이 얼마나 많은지!',
      '그런 당신을 위해 준비했어요.',
    ]
  );
  const centerData1 = { centerDesc: ['시설/장비'] };
  const centerData2 = { centerDesc: ['이렇게 사용하면 좋아요'] };

  const logGridCreator = (imgSrc, mainDesc1, mainDesc2, subDesc1, subDesc2) => {
    return {
      imgSrc: imgSrc,
      mainDesc1: mainDesc1,
      mainDesc2: mainDesc2,
      subDesc1: subDesc1,
      subDesc2: subDesc2,
    };
  };
  const usageGridCreator = (imgSrc, mainDesc1, mainDesc2) => {
    return {
      imgSrc: imgSrc,
      mainDesc1: mainDesc1,
      mainDesc2: mainDesc2,
    };
  };
  const logs = () => {
    return [
      logGridCreator(
        '/imgs/log1.jpeg',
        '널찍한 공간',
        '넓은 공간, 소파, 바',
        '20명 이상 수용 가능한 공간!',
        '친구들과 다양하게 활용할 수 있어요.'
      ),
      logGridCreator(
        '/imgs/log2.jpg',
        '공연용 음향장비',
        '앰프, 마이크, 건반',
        '소규모 강의 및 레슨도 문제없어요.',
        '24시간 방해받지 않고 연주할 수 있어요.'
      ),
      logGridCreator(
        '/imgs/log3.jpeg',
        '전문가급 조명',
        '핀포인트 조명, 카메라 조명',
        '실내의 낮은 조도를 걱정할 필요가 없어요.',
        '유튜브 촬영과 소규모 공연에 적합해요.'
      ),
      logGridCreator(
        '/imgs/log4.jpg',
        '우리만의 영화관',
        '빔 프로젝터, 스크린, 배달음식',
        '치맥 먹으면서 넷플릭스 보기!',
        '배달음식 취식과 유튜브 시청도 가능해요.'
      ),
    ];
  };
  const usages = () => {
    return [
      usageGridCreator(
        '/imgs/usage1.jpg',
        '기타/피아노 등 악기 레슨실',
        '합주실 & 연습실'
      ),
      usageGridCreator('/imgs/usage2.jpeg', '유튜브촬영', '소규모 콘서트'),
      usageGridCreator('/imgs/usage3.jpeg', '그룹스터디', '소규모 세미나'),
      usageGridCreator('/imgs/usage4.jpg', '넷플릭스/유튜브 감상', '파티룸'),
    ];
  };
</script>

<section class="container">
  <Section {...sectionData} />
  <VerticalSpacing marginTop="130" />
  <CenterDesc {...centerData1} />
  <VerticalSpacing marginTop="50" />

  <div class="log-grid">
    {#each logs() as log}
      <LogGrid {...log} />
    {/each}
  </div>
  <VerticalSpacing marginTop="160" />
  <CenterDesc {...centerData2} />
  <VerticalSpacing marginTop="50" />

  <div class="usage-grid">
    {#each usages() as usage}
      <UsageCard {...usage} />
    {/each}
  </div>
  <VerticalSpacing marginTop="160" />
</section>

<style>
  .container {
    width: 64%;
    margin: 0 auto;
  }
  .log-grid,
  .usage-grid {
    display: grid;
    grid-template-columns: 1fr 1fr;
    column-gap: 20px;
    row-gap: 20px;
  }
  .usage-grid {
    column-gap: 0px;
    row-gap: 0px;
  }
  @media screen and (max-width: 1300px) {
    .container {
      width: 90%;
    }
  }
  @media screen and (max-width: 768px) {
    .container {
      width: 96%;
      margin: 0 auto;
    }
  }

  @media screen and (max-width: 768px) {
    .log-grid,
    .usage-grid {
      grid-template-columns: 1fr;
      /* grid-auto-flow: row; */
    }
  }
</style>
